module.exports = __webpack_public_path__ + "static/img/20040B_1_2_3_4_5_C_20230522_LC.de708ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20040B_1_2_3_4_5_C_20230522_LC.png
// module id = acsq
// module chunks = 0